import TipoActivoService from 'src/modules/tipoActivo/tipoActivoService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'TIPOACTIVO_FORM';

const tipoActivoFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: tipoActivoFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await TipoActivoService.find(id);
      }

      dispatch({
        type: tipoActivoFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: tipoActivoFormActions.INIT_ERROR,
      });

      getHistory().push('/tipo-activo');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: tipoActivoFormActions.CREATE_STARTED,
      });

      await TipoActivoService.create(values);

      dispatch({
        type: tipoActivoFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.tipoActivo.create.success'),
      );

      getHistory().push('/tipo-activo');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: tipoActivoFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: tipoActivoFormActions.UPDATE_STARTED,
      });

      await TipoActivoService.update(id, values);

      dispatch({
        type: tipoActivoFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.tipoActivo.update.success'),
      );

      getHistory().push('/tipo-activo');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: tipoActivoFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default tipoActivoFormActions;
